import { Box, Grid, Typography } from "@mui/material";
import { displayNo } from "../../../helper/Number";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "@mui/material/Pagination";
import { useCallback, useEffect, useState } from "react";
import { sagaActions } from "../../../redux/sagas/sagaActions";
import { OREDER_STATUS, ROUTE_PATH } from "../../../helper/Constants";
import Payment from "../Payment/Payment";
import { Link } from "react-router-dom";
import { getLocalStorage } from "../../../helper/Storage";

const OrderGrid = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const address = useSelector((state) => state.address.address);
  const orders = useSelector((state) => state.myOrders.orders);
  const totalPage = useSelector((state) => state.myOrders.totalPage);
  const incenses = useSelector((state) => state.incenses.items);
  const spices = useSelector((state) => state.spices.items);

  const lan = getLocalStorage("userLanguage");

  const [pageNo, setPageNo] = useState(1);

  const handlePageChange = useCallback(
    (e, value) => {
      if (address.phone) {
        setPageNo(value);
        dispatch({
          type: sagaActions.ORDERS_LOAD_REQUEST,
          phone: address.phone,
          pageNo: value ?? 1,
        });
      }
    },
    [address, dispatch],
  );

  const getRowColor = (status) => {
    switch (status) {
      case OREDER_STATUS.ORDERED:
        return "#000000";
      case OREDER_STATUS.PAID:
        return "#06ac21";
      case OREDER_STATUS.PAYMENT_FAILED:
        return "#ff0000";
      case OREDER_STATUS.INTRANSIT:
        return "#889200";
      case OREDER_STATUS.DELIVERED:
        return "#020475";
      case OREDER_STATUS.DELETED:
        return "#353535";
      default:
        return "#ffffff";
    }
  };

  useEffect(() => {
    handlePageChange();
  }, [address, handlePageChange]);

  return (
    <Grid container>
      <Grid sx={{ padding: "5px" }} size={{ xs: 12 }} className="container">
        {[...orders]?.map((order, index) => (
          <Grid
            container
            key={"order_" + index}
            sx={{
              padding: 1,
              textAlign: "center",
              color: getRowColor(order.status),
              marginBottom: "5px",
            }}
            className="row"
          >
            <Grid size={{ sm: 3, md: 2, xs: 7 }} sx={{ textAlign: "left" }}>
              <Payment order={order}></Payment>
            </Grid>
            <Grid
              size={{ sm: 9, md: 2, xs: 5 }}
              sx={{ textAlign: "left", padding: "5px" }}
            >
              <Typography>
                <strong>{t("my-orders.orderNo")}: </strong>
                {displayNo(order?.orderNo)}
              </Typography>
              <Typography>
                <strong>{t("my-orders.phone")}: </strong>{" "}
                {displayNo(order?.phone)}
              </Typography>
              <Typography>
                <strong>{t("my-orders.address")}: </strong>
                {order?.address}
              </Typography>
              <Typography>
                <strong>{t("my-orders.status")}: </strong>
                {t("my-orders.status." + order?.status.toLowerCase())}
              </Typography>
              <Typography>
                <strong>{t("my-orders.comments")}: </strong> {order?.comments}
              </Typography>
              <Typography>
                <strong>{t("my-orders.created")}: </strong> {displayNo(order?.createOn)}
              </Typography>
              <Typography>
                <strong>{t("my-orders.updated")}: </strong> {displayNo(order?.updateOn)}
              </Typography>
            </Grid>
            <Grid
              size={{ sm: 12, md: 6, xs: 12 }}
              sx={{ borderTop: "1px solid #ababab50" }}
            >
              {order?.items.map((item) => {
                const product =
                  item.type === ROUTE_PATH.INCENSES
                    ? incenses.filter(
                        (incense) => incense.id === item.itemId,
                      )[0]
                    : spices.filter((spice) => spice.id === item.itemId)[0];
                return (
                  <Grid
                    container
                    key={item.id}
                    sx={{ padding: "5px", borderBottom: "1px solid #ababab50" }}
                  >
                    <Grid
                      size={{ md: 2, xs: 4 }}
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                      }}
                    >
                      <Link
                        to={
                          "/" +
                          ROUTE_PATH.PRODUCT_DETAILS +
                          item.itemId +
                          "/" +
                          item.type
                        }
                        style={{ textAlign: "left" }}
                      >
                        <img
                          src={
                            process.env.REACT_APP_API_URL + product?.thumbnail
                          }
                          alt={product?.thumbnail}
                          className="checkout-img"
                        ></img>
                      </Link>
                    </Grid>
                    <Grid size={{ md: 10, xs: 8 }} container>
                      <Grid
                        size={{ lg: 4 }}
                        sx={{ padding: "5px", textAlign: "left" }}
                      >
                        {product?.name.find((n) => n.key === lan)?.value}
                      </Grid>
                      <Grid
                        size={{ lg: 7 }}
                        sx={{ padding: "5px", textAlign: "left" }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: "bold",
                            padding: "0 3px",
                            fontSize: "15px",
                          }}
                        >
                          ₹{displayNo(Number(item.offerPrice).toFixed(2))}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            textDecoration: "line-through",
                            color: "#888888ff",
                          }}
                        >
                          ₹
                          {displayNo(
                            Number(item.actualPrice * item.count).toFixed(2),
                          )}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: "bold",
                            padding: "0 3px",
                            color: "#28d311ff",
                          }}
                        >
                          {displayNo(
                            (
                              (100 * (item.actualPrice - item.offerPrice)) /
                              item.actualPrice
                            ).toFixed(2),
                          )}
                          %{t("off")}
                        </Typography>
                      </Grid>
                      <Grid
                        size={{ lg: 1 }}
                        sx={{
                          padding: "5px",
                        }}
                      >
                        <Typography
                          sx={{
                            textAlign: "left",
                            minWidth: "35px",
                          }}
                        >
                          {displayNo(item.count.toString())}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
            <Grid
              size={{ sm: 12, md: 2, xs: 12 }}
              sx={{ textAlign: "left", padding: "5px" }}
            >
              <Box variant="span" sx={{ padding: "10px 20px 10px 0" }}>
                {t("my-orders.item-total")}: ₹{" "}
                {displayNo(
                  order?.items
                    ?.reduce(
                      (a, v) =>
                        (a =
                          parseFloat(a) +
                          parseFloat(v.offerPrice) * parseFloat(v.count)),
                      0,
                    )
                    .toFixed(2),
                )}
              </Box>
              <Box variant="span" sx={{ padding: "10px 20px 10px 0" }}>
                {t("my-orders.delivery-fee")}: ₹{" "}
                {displayNo(parseFloat(order?.deliveryFee).toFixed(2))}
              </Box>
              <Box variant="span" sx={{ padding: "10px 20px 10px 0" }}>
                {t("my-orders.discount")}: ₹{" "}
                {displayNo(parseFloat(order?.discount).toFixed(2))}
              </Box>
              <Typography
                variant="h7"
                sx={{ padding: "10px 20px 10px 0", fontWeight: "bold" }}
              >
                {t("my-orders.grand-total")}: ₹{" "}
                {displayNo(
                  (
                    order?.items.reduce(
                      (a, v) =>
                        (a =
                          parseFloat(a) +
                          parseFloat(v.offerPrice) * parseFloat(v.count)),
                      0,
                    ) +
                    parseFloat(order?.deliveryFee) -
                    parseFloat(order?.discount)
                  ).toFixed(2),
                )}
              </Typography>
            </Grid>
          </Grid>
        ))}
        {totalPage > 0 && (
          <Pagination
            count={totalPage}
            page={pageNo}
            color="primary"
            onChange={handlePageChange}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default OrderGrid;
